import { getBlogArticleByID } from "app/services/blogServices"
import { useEffect } from "react"
import { useState } from "react"

export const useArticle = (articleID) => {

  const [article, setArticle] = useState(null)

  useEffect(() => {
    setArticle(getBlogArticleByID(articleID))
  },[articleID])

  return article

}